/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getFinanceAggregatedStats } from "../../../actions";
import AppGrids from "../../../components/AppGrids";
import Popup from "reactjs-popup";
import "./styles.scss";
import Inputs from "../../../components/Inputs";
import PeriodSelector from "../../../components/PeriodSelector";
import moment from "moment";
import Header from "../../../components/Header/Header";
import { useLocation } from "react-router-dom";
import { history } from "../../../config/stores";

const cardTypes = [
  {
    header: "Created Wallets",
    firstLine: "Total number of created wallets",
    secondLine: "Total number of users creating wallets",
    firstField: "walletsCount",
    secondField: "usersCreatingWallets",
    tab: "created-wallets",
  },
  {
    header: "Transactions",
    firstLine: "Total numbers of added transactions",
    secondLine: "Total numbers of users adding transaction",
    firstField: "transactionsCount",
    secondField: "usersAddingTransactions",
    tab: "transactions",
  },
  {
    header: "Shared Wallets",
    firstLine: "Total numbers of shared wallet",
    secondLine: "Total numbers of using wallet",
    firstField: "sharedWalletsCount",
    secondField: "usersUsingWallets",
    tab: "shared-wallets",
  },
  {
    header: "Bank Integrations",
    firstLine: "Total numbers of integrations",
    secondLine: "Total numbers of users making integrations",
    firstField: "bankAccountsCount",
    secondField: "usersCreatingBankAccounts",
    tab: "bank-integrations",
  },
];

const AppFinances = ({ financeStats, getFinanceAggregatedStats }) => {
  const location = useLocation();
  const scrollContainerRef = useRef(null);
  
  // Get tab from URL params or default to first tab
  const getInitialTab = () => {
    const urlParams = new URLSearchParams(location.search);
    const tabFromUrl = urlParams.get('tab');
    return tabFromUrl && cardTypes.find(card => card.tab === tabFromUrl) ? tabFromUrl : "created-wallets";
  };
  
  const [selTab, setSelTab] = useState(getInitialTab());
  const [selPeriod, setSelPeriod] = useState({
    startDate: null,
    endDate: null,
  });
  const [selectedPeriodLabel, setSelectedPeriodLabel] = useState("All time");
  const [selectedPeriodType, setSelectedPeriodType] = useState("all");

  // Handle period changes from the new PeriodSelector
  const handlePeriodApply = (periodData) => {
    setSelPeriod({
      startDate: periodData.startDate,
      endDate: periodData.endDate,
    });
    setSelectedPeriodLabel(periodData.label);
    setSelectedPeriodType(periodData.type);
  };

  // Save scroll position to localStorage
  const saveScrollPosition = () => {
    if (scrollContainerRef.current) {
      const scrollLeft = scrollContainerRef.current.scrollLeft;
      localStorage.setItem('app-finances-scroll', scrollLeft.toString());
    }
  };

  // Restore scroll position from localStorage
  const restoreScrollPosition = () => {
    const savedScrollPosition = localStorage.getItem('app-finances-scroll');
    if (savedScrollPosition && scrollContainerRef.current) {
      setTimeout(() => {
        scrollContainerRef.current.scrollLeft = parseInt(savedScrollPosition, 10);
      }, 100); // Small delay to ensure DOM is ready
    }
  };

  // Handle tab change with URL update and scroll save
  const handleTabChange = (newTab) => {
    setSelTab(newTab);
    
    // Update URL without causing page reload
    const newUrl = `/app/finances?tab=${newTab}`;
    history.replace(newUrl);
    
    // Save current scroll position
    saveScrollPosition();
  };

  // Restore state on mount
  useEffect(() => {
    // Restore scroll position
    restoreScrollPosition();
    
    // Listen for scroll changes to save position
    const handleScroll = () => {
      saveScrollPosition();
    };
    
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
      return () => container.removeEventListener('scroll', handleScroll);
    }
  }, []);

  // Update tab when URL changes (browser back/forward)
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabFromUrl = urlParams.get('tab');
    if (tabFromUrl && cardTypes.find(card => card.tab === tabFromUrl)) {
      setSelTab(tabFromUrl);
    }
  }, [location.search]);

  // Function to load finance stats based on period
  const loadFinanceStats = (period = selPeriod) => {
    let statsPayload;
    
    // Check if this is "All time" selection (both null) or initial load
    if (!period?.startDate && !period?.endDate) {
      // For "All time", send empty strings like other Statistics components
      statsPayload = {
        startDate: "",
        endDate: ""
      };
    } else {
      // For specific periods, send the actual dates
      statsPayload = {
        startDate: period?.startDate || "",
        endDate: period?.endDate || ""
      };
    }

    // Load finance aggregated stats
    getFinanceAggregatedStats(statsPayload);
  };

  useEffect(() => {
    loadFinanceStats();
  }, []);

  // Update stats when period changes
  useEffect(() => {
    loadFinanceStats(selPeriod);
  }, [selPeriod]);

  // Prepare display stats with finance data
const displayStats = {
  
  walletsCount: financeStats?.wallets?.wallets || 0,
  usersCreatingWallets: financeStats?.wallets?.users || 0,
  transactionsCount: financeStats?.transactions?.transactions || 0,
  usersAddingTransactions: financeStats?.transactions?.users || 0,
  sharedWalletsCount: financeStats?.invitations?.invitations || 0,
  usersUsingWallets: financeStats?.invitations?.users || 0,
  bankAccountsCount: financeStats?.bankAccounts?.accountsCount || 0,
  usersCreatingBankAccounts: financeStats?.bankAccounts?.usersCount || 0,
};

  return (
    <>
      <Header />
      <div className="main-container app-finances"> {/* ✅ ADD: app-finances class */}
        <div
          ref={scrollContainerRef}
          className="app-header-container" // ✅ CHANGED: Use shared class name
          style={{
            height: "auto",
            width: "100%", // ✅ CHANGED: Use full width
            padding: "10px",
            display: "flex",
            overflowX: "scroll",
            overflowY: "hidden",
          }}
        >
          {cardTypes.map((card, i) => {
            return (
              <div
                key={i}
                className={`card-grid ${
                  card.tab === selTab && "selected"
                }`}
              >
                <div
                  className={`card-header ${
                    card.tab === selTab && "selected"
                  }`}
                  onClick={() => {
                    handleTabChange(card.tab);
                  }}
                >
                  <h2
                    className={`${
                      card.tab === selTab ? "font-bold" : "font-semiBold"
                    }`}
                    style={{
                      textTransform: "uppercase",
                      width: "93%",
                      marginLeft: "5px",
                    }}
                  >
                    {card.header}
                  </h2>
                  <p style={{ whiteSpace: "nowrap" }}>
                    {selectedPeriodLabel}
                  </p>
                  <Popup
                    className="popup-header-options-container"
                    trigger={
                      <div
                        className={`settings-icon ${
                          card.tab === selTab && "selected"
                        }`}
                      />
                    }
                    position="bottom right"
                    closeOnDocumentClick
                  >
                    {(close) => (
                      <PeriodSelector
                        selectedPeriod={selectedPeriodType}
                        isLastCard={i === cardTypes.length - 1}
                        onApply={(periodData) => {
                          handlePeriodApply(periodData);
                          close();
                        }}
                      />
                    )}
                  </Popup>
                </div>
                <div className="card-body">
                  <div className="card-row">
                    <div className="indicator blue" />
                    <p className="row-data">
                      <b>{displayStats?.[card?.firstField] || "---"} </b>
                      <br />
                      <span className="metric-text">
                        {card.firstLine}
                      </span>
                    </p>
                  </div>
                  <div className="card-row">
                    <div className="indicator blue" />
                    <p className="row-data">
                      <b>{displayStats?.[card?.secondField] || "---"} </b>
                      <br />
                      <span className="metric-text">
                        {card.secondLine}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="body-container" style={{ height: "73%" }}>
          {selTab === "created-wallets" ? (
            <AppGrids.Wallets period={selPeriod} />
          ) : selTab === "transactions" ? (
            <AppGrids.Transactions period={selPeriod} />
          ) : selTab === "shared-wallets" ? (
            <AppGrids.SharedWallets period={selPeriod} />
          ) : selTab === "bank-integrations" ? (
            <AppGrids.BankIntegrations period={selPeriod} />
          ) : (
            <div>Select a tab to view data</div>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  financeStats: state.appFinances.financeStats, // ✅ Changed from state.app.financeStats
});

const mapDispatchToProps = (dispatch) => ({
  getFinanceAggregatedStats: (payload) => dispatch(getFinanceAggregatedStats(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppFinances);